import Cookies from 'js-cookie';
import $ from 'jquery';

const PRIVACY_COOKIE_NAME = 'consent_privacy';

class CookieConsent {
  addListeners() {
    $(document).on('click', '.js-set-consent', (e) => {
      e.preventDefault();
      Cookies.set(PRIVACY_COOKIE_NAME, 1, {path: '/', expires: 365});

      $('.js-consent-message').animate({bottom: '-100%'}, 1200, 'linear', () => {
        $('.js-consent-message').remove();
      });
    });
  }

  init = () => {
    this.addListeners();
  };
}

export default CookieConsent;
